import { ChatMessage, AgentType, PromptType, MessageData, MessageMetadata } from '../models';

export interface CreateMessageOptions {
  content: string;
  isUser: boolean;
  promptType?: PromptType;
  agentType?: AgentType;
  threadId?: string;
  executionId?: string;
  isStreaming?: boolean;
  data?: MessageData;
  metadata?: MessageMetadata;
}

export class ChatMessageFactory {
  private static generateId(): string {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  public static createMessage(options: CreateMessageOptions): ChatMessage {
    return {
      id: this.generateId(),
      content: options.content,
      timestamp: new Date(),
      isUser: options.isUser,
      promptType: options.promptType,
      agentType: options.agentType,
      threadId: options.threadId,
      executionId: options.executionId,
      isStreaming: options.isStreaming ?? false,
      data: options.data,
      metadata: options.metadata
    };
  }

  public static createUserMessage(
    content: string, 
    threadId?: string, 
    agentType?: AgentType
  ): ChatMessage {
    return this.createMessage({
      content,
      isUser: true,
      threadId,
      agentType
    });
  }

  public static createAssistantMessage(
    content: string,
    agentType?: AgentType,
    threadId?: string,
    executionId?: string,
    metadata?: ChatMessage['metadata']
  ): ChatMessage {
    return this.createMessage({
      content,
      isUser: false,
      agentType,
      threadId,
      executionId,
      metadata
    });
  }

  public static createStreamingMessage(
    content: string,
    agentType?: AgentType,
    threadId?: string,
    executionId?: string
  ): ChatMessage {
    return this.createMessage({
      content,
      isUser: false,
      agentType,
      threadId,
      executionId,
      isStreaming: true
    });
  }

  public static fromThreadMessage(
    threadMessage: {
      role: 'user' | 'assistant';
      content: string;
      timestamp: string;
      metadata?: Record<string, unknown>;
    },
    threadId?: string,
    agentType?: AgentType
  ): ChatMessage {
    return {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${threadMessage.role}`,
      content: threadMessage.content,
      timestamp: new Date(threadMessage.timestamp),
      isUser: threadMessage.role === 'user',
      threadId,
      agentType,
      isStreaming: false,
      metadata: threadMessage.metadata
    };
  }
}